import React from 'react';
import { FormFieldV2 } from '@/components/custom/erp/form-field-v2';
import { Label } from '@/components/ui/label';

interface DocumentNumberRangeFieldV2Props {
  label?: string;
  fromName?: string;
  toName?: string;
  labelClassName?: string;
  className?: string;
  disabled?: boolean;
  formMode?: string;
}

export const DocumentNumberRangeFieldV2: React.FC<DocumentNumberRangeFieldV2Props> = ({
  label = 'Số c/từ (từ/đến)',
  fromName = 'so_ct1',
  toName = 'so_ct2',
  labelClassName = 'w-[138px] shrink-0 text-[13px]',
  className = 'flex items-center',
  disabled = false
}) => {
  return (
    <div className={className}>
      <Label className={labelClassName}>{label}</Label>
      <div className='flex flex-1 gap-2'>
        <FormFieldV2 name={fromName} type='text' className='w-full' disabled={disabled} />
        <FormFieldV2 name={toName} type='text' className='w-full' disabled={disabled} />
      </div>
    </div>
  );
};

export default DocumentNumberRangeFieldV2;
